/*
 * XMYPICK Niche Storefront Engine — xn- section behaviours.
 *
 * Deliberately small and dependency-free. Everything here is progressive
 * enhancement: each feature degrades to plain server-rendered HTML.
 *
 *   1. Announcement bar rotation (max two messages, pause on focus/hover)
 *   2. Pincode / ETA checker (local computation only — no external API)
 *   3. Sticky add-to-cart (shown only after the inline ATC scrolls out of view)
 *
 * No network request is made by this file.
 */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- 1. Bar */

  function initAnnouncement(bar) {
    var messages = bar.querySelectorAll('[data-xn-announcement-message]');
    var closeButton = bar.querySelector('[data-xn-announcement-close]');
    var storageKey = 'xn_announcement_dismissed_' + (bar.getAttribute('data-xn-id') || 'default');

    try {
      if (window.localStorage.getItem(storageKey) === '1') {
        bar.hidden = true;
        return;
      }
    } catch (error) {
      /* storage unavailable — the bar simply always shows */
    }

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        bar.hidden = true;
        try {
          window.localStorage.setItem(storageKey, '1');
        } catch (error) {
          /* ignore */
        }
      });
    }

    if (messages.length < 2 || reduceMotion) return;

    var index = 0;
    var paused = false;
    var dwell = parseInt(bar.getAttribute('data-xn-dwell'), 10) || 6000;

    bar.addEventListener('mouseenter', function () {
      paused = true;
    });
    bar.addEventListener('mouseleave', function () {
      paused = false;
    });
    bar.addEventListener('focusin', function () {
      paused = true;
    });
    bar.addEventListener('focusout', function () {
      paused = false;
    });

    window.setInterval(function () {
      if (paused || bar.hidden) return;
      messages[index].classList.remove('is-active');
      index = (index + 1) % messages.length;
      messages[index].classList.add('is-active');
    }, dwell);
  }

  /* ------------------------------------------------------------ 2. Pincode */

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function formatDate(date) {
    return date.getDate() + ' ' + MONTHS[date.getMonth()];
  }

  function addDays(date, days) {
    var next = new Date(date.getTime());
    next.setDate(next.getDate() + days);
    return next;
  }

  function initPincode(block) {
    var form = block.querySelector('[data-xn-pincode-form]');
    var input = block.querySelector('[data-xn-pincode-input]');
    var result = block.querySelector('[data-xn-pincode-result]');
    if (!form || !input || !result) return;

    var minDays = parseInt(block.getAttribute('data-xn-min-days'), 10);
    var maxDays = parseInt(block.getAttribute('data-xn-max-days'), 10);
    if (isNaN(minDays)) minDays = 3;
    if (isNaN(maxDays)) maxDays = 5;
    if (maxDays < minDays) maxDays = minDays;

    var codTemplate = block.getAttribute('data-xn-cod-text') || '';
    var errorText = block.getAttribute('data-xn-error-text') || 'Enter a valid 6-digit pincode.';
    var deliveryTemplate = block.getAttribute('data-xn-delivery-text') || 'Delivery between [range]';

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var value = (input.value || '').replace(/\s+/g, '');

      if (!/^[1-9][0-9]{5}$/.test(value)) {
        result.setAttribute('data-state', 'error');
        result.textContent = errorText;
        return;
      }

      var today = new Date();
      var from = addDays(today, minDays);
      var to = addDays(today, maxDays);
      var range =
        minDays === maxDays
          ? formatDate(from)
          : formatDate(from) + ' – ' + formatDate(to);

      result.setAttribute('data-state', 'ok');
      result.textContent = deliveryTemplate.replace('[range]', range) + (codTemplate ? ' · ' + codTemplate : '');
    });
  }

  /* --------------------------------------------------------- 3. Sticky ATC */

  function initStickyAtc(bar) {
    /*
     * The store already ships an xm-sticky-atc section on some product templates.
     * Two stacked sticky bars would eat the viewport, so the xn bar stands down
     * whenever another one is present on the page.
     */
    if (document.querySelector('[data-xm-sticky-atc], [data-sticky-atc]')) {
      bar.parentNode && bar.parentNode.removeChild(bar);
      return;
    }

    var anchorId = bar.getAttribute('data-xn-anchor');
    var anchor = anchorId ? document.getElementById(anchorId) : null;
    if (!anchor || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          /* Never on page load: only once the inline ATC has scrolled out of view. */
          if (entry.isIntersecting || entry.boundingClientRect.top > 0) {
            bar.classList.remove('is-visible');
          } else {
            bar.classList.add('is-visible');
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(anchor);

    /* Hide while any modal or dialog is open. */
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (target && target.closest && target.closest('[data-xn-sticky-variant]')) {
        var selector = document.querySelector('variant-selects, .product-form__input');
        if (selector && selector.scrollIntoView) {
          selector.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        }
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-xn-announcement]').forEach(function (bar) {
      initAnnouncement(bar);
    });
    document.querySelectorAll('[data-xn-pincode]').forEach(function (block) {
      initPincode(block);
    });
    document.querySelectorAll('[data-xn-sticky-atc]').forEach(function (bar) {
      initStickyAtc(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
